import { apiFetch, apiFetchWithRetry } from '@/lib/apiFetch';
import { handleUnauthorized } from './UserManagmentServices';

export interface TeacherNotificationPreferences {
  inquiryReceived: boolean;
  threadReply: boolean;
  profileReviewResult: boolean;
  weeklyInquiryDigest: boolean;
  unreadReminder: boolean;
}

export async function fetchTeacherSettings(
  accessToken: string
): Promise<TeacherNotificationPreferences> {
  const response = await apiFetchWithRetry('/api/userManagement/v1/me/teacher-settings', {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (response.status === 401) handleUnauthorized();
  if (!response.ok) throw new Error(`Failed to fetch teacher settings: ${response.status}`);
  return response.json();
}

export async function updateTeacherSettings(
  accessToken: string,
  patch: Partial<TeacherNotificationPreferences>
): Promise<TeacherNotificationPreferences> {
  const response = await apiFetch('/api/userManagement/v1/me/teacher-settings', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(patch),
  });
  if (response.status === 401) handleUnauthorized();
  if (!response.ok) throw new Error(`Failed to update teacher settings: ${response.status}`);
  return response.json();
}
